import React from 'react';
import "../style/AgeConfirmation.css";

const MessageModal = ({ isOpen, onClose, message, closeText }) => {
  if (!isOpen) return null;

  return (
    <div className={`centered-overlay less-blur`} onClick={onClose}>
      <div className="spinner">
          <div className="age-confirmation-overlay">
            <div className="age-confirmation-modal">
              <h3>{message}</h3>
              <div className="age-confirmation-buttons">
                <button className="form-button full-width" onClick={onClose}>{closeText}</button>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default MessageModal;
